<template>
  <div
    v-show="visible"
    :position="position"
    :menu-items="menuItems"
    class="context-menu"
    :style="menuStyle"
    @click.stop
    @contextmenu.prevent
  >
    <div class="context-menu-content">
      <div
        v-for="(item, index) in menuItems.filter(e => e.visible)"
        :key="index"
        class="context-menu-item"
        :class="{
          'context-menu-item--disabled': item.disabled,
          'context-menu-item--divider': item.divider
        }"
        @click="handleItemClick(item)"
      >
        <template v-if="!item.divider">
          <i
            v-if="item.icon"
            :class="item.icon"
            class="context-menu-item__icon"
          ></i>
          <span class="context-menu-item__text">{{ item.text }}</span>
          <!-- <span v-if="item.shortcut" class="context-menu-item__shortcut">{{
            item.shortcut
          }}</span> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    },
    menuItems: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      adjustedPosition: { x: 0, y: 0 }
    }
  },

  computed: {
    menuStyle() {
      return {
        left: `${this.adjustedPosition.x}px`,
        top: `${this.adjustedPosition.y}px`
      }
    }
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.calculatePosition()
        })
      }
    },
    position: {
      handler() {
        if (this.visible) {
          this.$nextTick(() => {
            this.calculatePosition()
          })
        }
      },
      deep: true
    }
  },
  mounted() {
    // 点击其他地方隐藏菜单
    document.addEventListener('click', this.handleDocumentClick)
    // 监听窗口大小变化，重新计算位置
    window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    /**
     * 计算菜单的最佳显示位置，防止超出视口边界
     */
    calculatePosition() {
      if (!this.$el) return

      const menuRect = this.$el.getBoundingClientRect()
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      let { x, y } = this.position

      // 获取菜单的实际尺寸
      const menuWidth = menuRect.width || this.$el.offsetWidth || 120 // 默认最小宽度
      const menuHeight = menuRect.height || this.$el.offsetHeight || 100 // 默认最小高度

      // 安全边距
      const margin = 10

      // 水平位置调整
      if (x + menuWidth + margin > viewportWidth) {
        // 如果右边超出，尝试向左偏移
        x = viewportWidth - menuWidth - margin

        // 如果向左偏移后仍然超出左边界，则贴左边显示
        if (x < margin) {
          x = margin
        }
      } else if (x < margin) {
        // 如果左边超出，贴左边显示
        x = margin
      }

      // 垂直位置调整
      if (y + menuHeight + margin > viewportHeight) {
        // 如果底部超出，尝试向上偏移
        y = viewportHeight - menuHeight - margin

        // 如果向上偏移后仍然超出顶部，则贴顶部显示
        if (y < margin) {
          y = margin
        }
      } else if (y < margin) {
        // 如果顶部超出，贴顶部显示
        y = margin
      }

      this.adjustedPosition = { x, y }
    },

    /**
     * 处理窗口大小变化
     */
    handleWindowResize() {
      if (this.visible) {
        this.calculatePosition()
      }
    },

    handleItemClick(item) {
      if (item.disabled || item.divider) return
      item.click?.()
      this.$emit('hide') // 隐藏菜单
    },
    handleDocumentClick(e) {
      // 检查点击是否在右键菜单内部
      if (this.$el && this.$el.contains(e.target)) {
        return
      }
      this.$emit('hide')
    }
  }
}
</script>

<style lang="less" scoped>
.context-menu {
  position: fixed;
  z-index: 9999;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 4px 0;
  min-width: 120px;
  font-size: 14px;
  color: #606266;

  .context-menu-content {
    .context-menu-item {
      display: flex;
      align-items: center;
      padding: 4px 16px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover:not(.context-menu-item--disabled):not(
          .context-menu-item--divider
        ) {
        background-color: #f5f7fa;
      }

      &--disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }

      &--divider {
        height: 1px;
        background-color: #e4e7ed;
        margin: 4px 0;
        padding: 0;
        cursor: default;
      }

      &__icon {
        margin-right: 8px;
        font-size: 14px;
      }

      &__text {
        flex: 1;
      }

      &__shortcut {
        color: #909399;
        font-size: 12px;
        margin-left: 16px;
      }
    }
  }
}
</style>
